import { BaseModel } from "../../../../service/models/base";

export interface ItemWarehouseModel {
  inventoryItemCode: string;
  requestedQty: number;
  receivedQty: number;
  itemPrice: number;
  itemUnit: string;
  itemName: string;
  itemDescription?: string;
  subCategory: string;
  itemHSN: string;
  deviceIds?: string[];
  type?: string;
  invoiceQty?: number;
  gst_applicable: boolean;
  tax_detail: TaxDetailBreakdown;
}
export interface TaxDetailBreakdown {
  igst: number;
  cgst: number;
  sgst: number;
}

export interface GRNAttachmentModel {
  id?: string;
  url: string;
  type: string;
  category: string;
  filename: string;
  size: number;
  voucher_id: string;
  invoice_number: string;
  created_at?: string;
  created_by?: string;
  created_by_name?: string;
}

export interface WarehouseInwardModel extends BaseModel {
  id: string;
  inward_order_id: string;
  type: string; // "PO" | "ST"
  poType?: string; //for Infra POs

  from: FromDetails;
  toWarehouse: FromDetails;

  expectedDate: string;

  totalPrice: number;
  currency?: string; // PO currency at creation ("INR" | "USD"); values stored in INR
  vendor_currency_to_inr?: number; // exchange rate frozen at PO creation (INR per 1 unit)
  totalOrderedQty: number;
  totalReceivedQty: number;
  status: string; //Pending / Partial / Received

  attachments?: GRNAttachmentModel[];
  items: ItemWarehouseModel[];
  past_disputes?: any[];
  deleted?: boolean;
  st_subtype?: string; // For ST Inwards: Replacement, Returnable
  faulty_items?: ItemWarehouseModel[]; // Only for ST Replacement subtype, list of faulty items being replaced
  is_disputed?: boolean; // Flag to indicate if the inward order is currently under dispute
}

export const DefaultWarehouseInward: WarehouseInwardModel = {
  id: "",
  inward_order_id: "",
  type: "",

  from: {
    id: "",
    name: "",
  },
  toWarehouse: {
    id: "",
    name: "",
  },

  expectedDate: "",

  totalPrice: 0,
  totalOrderedQty: 0,
  totalReceivedQty: 0,
  status: "",

  attachments: [],
  items: [
    {
      inventoryItemCode: "",
      requestedQty: 0,
      receivedQty: 0,
      itemPrice: 0,
      itemUnit: "",
      itemName: "",
      subCategory: "",
      deviceIds: [],
      itemHSN: "",
      type: "",
      invoiceQty: 0,
      gst_applicable: false,
      tax_detail: {
        igst: 0,
        cgst: 0,
        sgst: 0,
      },
    },
  ],
};

export interface LinkedInwardItemModel {
  item_name: string;
  item_code: string;
  accepted_qty: number;
  value: number;
  itemPrice?: number;
  device_ids: string[];
}

export interface LinkedInwardAttachmentModel {
  url: string;
  filename: string;
  type: string;
  invoice_number: string;
}

export interface LinkedInwardModel {
  ref_id: string;
  type: string;
  date: string;
  created_by_name?: string;
  items_count: number;
  accepted_qty: number;
  value: number;
  items: LinkedInwardItemModel[];
  attachments: LinkedInwardAttachmentModel[];
}

export interface AwaitingReturnItemModel {
  inventoryItemCode: string;
  itemName: string;
  requestedQty: number;
  itemPrice: number;
  subCategory: string;
  itemHSN?: string;
  itemUnit?: string;
  deviceIds?: string[];
}

export interface AwaitingReturnAddress {
  line1?: string;
  line2?: string;
  line3?: string;
  city?: string;
  state?: string;
  country?: string;
  pincode?: number | string;
}
export interface AwaitingReturnModel extends BaseModel {
  id: string;
  type?: string;
  st_subtype?: string;
  status?: string;
  inward_status?: string;
  from_warehouse_name?: string;
  from_warehouse_id?: string;
  expected_date?: string;
  expected_dispatch_date?: string;
  expected_return_date?: string;
  due_date?: string;
  totalOrderedQty?: number;
  totalReceivedQty?: number;
  pendingQty?: number;
  party_name?: string;
  customer_name?: string;
  vendor_name?: string;
  linked_reference?: string;
  linked_order_id?: string;
  complaint_id?: string;
  purpose?: string;
  description?: string;
  overdue_days?: number;
  is_overdue?: boolean;
  created_by_name?: string;
  destination_type?: string;
  converted_order_id?: string;
  shipping_address?: AwaitingReturnAddress;
  vendor_warehouse_address?: AwaitingReturnAddress;
  faulty_items?: AwaitingReturnItemModel[];
  items?: AwaitingReturnItemModel[];
}

interface FromDetails {
  id: string;
  name: string;
}
